<template>
  <UiMenu
    :model-value="modelValueLocal"
    :scroll-strategy="scrollStrategy"
    @update:model-value="handleChange"
  >
    <template #activator="{ props }">
      <slot name="activator" v-bind="{ props }" />
    </template>
    <UiList class="ui-dropdown__list">
      <slot />
    </UiList>
  </UiMenu>
</template>

<script setup lang="ts">
import UiList from '../UiList/UiList.vue';
import UiMenu, { type ScrollStrategy } from '../UiMenu/UiMenu.vue';

export interface Props {
  scrollStrategy?: ScrollStrategy;
}

const { scrollStrategy = 'reposition' } = defineProps<Props>();

const emit = defineEmits<(e: 'update:modelValue', value: boolean) => void>();

const modelValueLocal = defineModel({ default: false, type: Boolean });

const handleChange = (value: boolean): void => {
  modelValueLocal.value = value;
  emit('update:modelValue', value);
};
</script>

<style lang="scss" scoped>
.ui-dropdown__list {
  max-height: 400px;
  padding: 0;
}
</style>
